export default __webpack_public_path__ + "static/Logo_tribrand-27c51039e6dfed9a6f72c98dc4c47e49.jpg";